import { useCallback } from "react";
import moment from 'moment';
import { formatNumber, roundOfAcres, Unit } from "../../../helpers/unit";
import { API_DATE_FORMAT } from "../../../constants";

export const useCalculateKPI = (params) => {
    const { workedAcresById,
        workedAcresRequest, timezoneIdentifier } = params;
    const unit = Unit.getInstance();

    const getWorkedAcres = (id, shapeRefId) => {
        const workDetails = workedAcresById[`${shapeRefId}_${id}`]
            ? workedAcresById[`${shapeRefId}_${id}`] : null;
        const workedAcres = workDetails ? unit.toArea(workDetails.workedAcres, 2) : 0;
        return roundOfAcres(workedAcres);
    };

    const getAverageYield = (id, shapeDetails, loadCapacity) => {
        const totalAcres = shapeDetails && shapeDetails.regionDetails.totalAcres;
        const workedAcres = getWorkedAcres(id, shapeDetails.geo_shape_uuid);
        const isCompleted = isFieldCompleted(id, shapeDetails);
        let averageYield = 0;
        if (isCompleted) {
            averageYield = loadCapacity > 0 && totalAcres > 0
                ? formatNumber(unit.toFixedOf((unit.toWeight(loadCapacity) / totalAcres), 2))
                : 0;
        } else {
            averageYield = loadCapacity > 0 && workedAcres > 0
                ? formatNumber(unit.toFixedOf((unit.toWeight(loadCapacity) / workedAcres), 2))
                : 0;
        }
        return averageYield;
    };

    const getAverageYieldDetails = (id, shapeDetails, loadCapacity, type = 'total', tareLoadHistoryList, workedAcres) => {
        let loadWeight = loadCapacity;
        if (shapeDetails.geo_shape_uuid && loadCapacity && loadCapacity > 0) {
            const tareLoads = tareLoadHistoryList.filter((e) => e.field_geo_shape_uuid === shapeDetails.geo_shape_uuid);
            if (tareLoads && tareLoads.length > 0) {
                const tareCapacity = tareLoads.reduce((capacity, item) => capacity + item.load_capacity, 0);
                loadWeight = (loadCapacity - (tareCapacity && tareCapacity > 0 ? tareCapacity : 0));
            }
        }
        const totalAcres = shapeDetails && shapeDetails.regionDetails.totalAcres;
        workedAcres = (workedAcres && workedAcres > 0) ? workedAcres : getWorkedAcres(id, shapeDetails.geo_shape_uuid);
        let averageYield = 0;
        if (type === 'total') {
            averageYield = loadWeight > 0 && totalAcres > 0
                ? formatNumber(unit.toFixedOf((unit.toWeight(loadWeight) / totalAcres), 2))
                : 0;
        } else {
            averageYield = loadWeight > 0 && workedAcres > 0
                ? formatNumber(unit.toFixedOf((unit.toWeight(loadWeight) / workedAcres), 2))
                : 0;
        }
        return averageYield;
    };


    const isFieldCompleted = useCallback((workTypeId, shapeDetails) => {
        const workStatus = Array.isArray(shapeDetails.work_status)
            ? shapeDetails.work_status.filter(e => e.work_type_id === workTypeId) : [];
        const lastWorkStatus = workStatus.length > 0 ? workStatus[workStatus.length - 1] : null;

        if (lastWorkStatus && lastWorkStatus.work_status === 4 && workedAcresRequest && workedAcresRequest.end_date) {
            const completedDay = moment.utc(lastWorkStatus.work_status_date).tz(timezoneIdentifier);
            const completedDate = moment.utc(completedDay.format(API_DATE_FORMAT)).startOf("day");
            const requestToDate = moment.utc(workedAcresRequest.end_date);
            return (completedDate.year() >= requestToDate.year() && completedDate <= requestToDate);
        }
        return false;
    }, [workedAcresRequest]);

    return {
        getWorkedAcres,
        getAverageYield,
        isFieldCompleted,
        getAverageYieldDetails
    };
};